var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"pui-attribute-detail-panel"},[_c('label',{staticClass:"attribute-detail-label"},[_vm._v(_vm._s(_vm.piivoTranslate(_vm.detail)))]),_c(_vm.renderer,{tag:"component",staticClass:"attribute-detail-value",attrs:{"value":_vm.value,"formatter":_vm.formatter}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }